import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const DateRangeSelector = ({ value, onChange }) => {
  const getTodayRange = () => {
    const today = new Date();
    const start = new Date(today.setHours(0, 0, 0, 0));
    const end = new Date(today.setHours(23, 59, 59, 999));
    return [start, end];
  };

  const [dateRange, setDateRange] = useState(
    value && value.length === 2 && value[0] instanceof Date && value[1] instanceof Date
      ? value
      : getTodayRange()
  );

  // Sync local state with prop value
  useEffect(() => {
    if (
      !value ||
      value.length !== 2 ||
      !(value[0] instanceof Date) ||
      !(value[1] instanceof Date)
    ) {
      const todayRange = getTodayRange();
      setDateRange(todayRange);
      onChange(todayRange);
    } else {
      setDateRange(value);
    }
  }, [value, onChange]);

  const handleDateRangeChange = (selectedValue) => {
    if (selectedValue && selectedValue.length === 2) {
      const [start, end] = selectedValue;
      setDateRange([start, end]);
      onChange([start, end]); // Pass exact selected times
    } else {
      const todayRange = getTodayRange();
      setDateRange(todayRange);
      onChange(todayRange);
    }
  };

  return (
    <Box>
      <DateRangePicker
        format="MM/dd/yyyy hh:mm:ss a"
        showMeridiem={true}
        value={dateRange}
        style={{ width: "460px" }}
        label="From ~ To:"
        onChange={handleDateRangeChange}
        cleanable
        onShortcutClick={(range) => {
          if (range.label === "today") {
            handleDateRangeChange(getTodayRange());
          }
        }}
      />
    </Box>
  );
};

export default DateRangeSelector;